'use client'

export function HamburgerMenu({
  isOpen = false,
  setIsOpen,
  className = '',
  size = 'w-7 h-7',
  color = 'text-black',
  duration = '300ms',
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  className?: string
  size?: string
  color?: string
  duration?: string
}) {
  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div
      onClick={handleClick}
      data-open={isOpen}
      style={{ '--hamburger-duration': duration } as React.CSSProperties}
      className={`${className} hamburger-menu flex h-[42px] items-center rounded-md border-b-4 border-black/15 bg-neutral-200 px-2 active:border-0`}
    >
      <div
        className={`relative flex flex-col items-center justify-center ${size} ${color} rounded-md focus:outline-none`}
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </div>
    </div>
  )
}
